import { useTranslation } from 'next-i18next';

import { JobApplicationStatusKey } from '@restworld/utility-types';

export type KanbanRow = {
  title: string;
  matchStatusKey: JobApplicationStatusKey[];
  showCount?: boolean;
  id: 'interested' | 'interview' | 'stage' | 'hired' | 'discarded';
  icon?: 'DevicePhoneMobileIcon' | 'UserGroupIcon' | 'ClipboardCheckIcon';
};

export function useKanbanRowsAndMatchStatusKeys() {
  const { t } = useTranslation('job-positions-page');

  const kanbanRows: KanbanRow[] = [
    {
      title: t('to_be_called'),
      matchStatusKey: ['worker_jp_employer_interested'],
      id: 'interested' as const,
      icon: 'DevicePhoneMobileIcon' as const,
    },
    {
      title: t('to_be_interviewed'),
      matchStatusKey: ['worker_jp_interview_scheduled', 'worker_jp_interview_done'],
      id: 'interview' as const,
      icon: 'UserGroupIcon' as const,
    },
    {
      title: t('negotiation'),
      matchStatusKey: ['worker_jp_stage_scheduled', 'worker_jp_stage', 'worker_jp_stage_done'],
      id: 'stage' as const,
      icon: 'ClipboardCheckIcon' as const,
    },
    {
      title: t('to_be_hired'),
      matchStatusKey: ['worker_jp_hired', 'worker_jp_scheduled_hiring'],
      id: 'hired' as const,
    },
    // {
    //   title: t('to_be_rejected'),
    //   matchStatusKey: ['worker_jp_discarded'],
    //   showCount: true,
    //   id: 'discarded' as const,
    // },
  ];
  return kanbanRows;
}
